module.exports = __webpack_public_path__ + "img/img_size_06.830d500d.png";